module.exports = __webpack_public_path__ + "img/T1D_rc-15.9e6ecb68.png";